module.exports = __webpack_public_path__ + "sansg/img/a.89cfa76b.png";